import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/** Sends /vendor to login or dashboard based on vendor session. */
const VendorPortalEntry = () => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-[#FF5E4C] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Loading vendor portal…</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated && user && (user.role === 'vendor' || user.role === 'admin')) {
    return <Navigate to="/vendor/growth" replace />;
  }

  return <Navigate to="/vendor/login" replace />;
};

export default VendorPortalEntry;
